import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import actions from 'Actions';
import { userSelector } from 'selectors/user/userSelector';
import { showUpdateFastShippingCopyMeganavSMSelector } from 'viewModel/selectors/testTarget/showUpdateFastShippingCopyMeganavSMSelector';
import LanguageLocale from 'utils/LanguageLocale';
import SignInBannerEN from 'components/Homepage/SignInBanner/locales/SignInBanner_en_US';
import SignInBannerFR from 'components/Homepage/SignInBanner/locales/SignInBanner_fr_CA';

const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocale;
const getText = getLocalisedDataFromResource(SignInBannerEN, SignInBannerFR);

export default connect(
    createStructuredSelector({
        user: userSelector,
        showUpdateFastShippingCopyMeganavSM: showUpdateFastShippingCopyMeganavSMSelector,
        localization: createStructuredSelector({
            signInFree: getTextFromResource(getText, 'signInFree'),
            signInAccount: getTextFromResource(getText, 'signInAccount'),
            signInAccountLink: getTextFromResource(getText, 'signInAccountLink'),
            signInCTA: getTextFromResource(getText, 'signInCTA'),
            status: getTextFromResource(getText, 'status'),
            points: getTextFromResource(getText, 'points'),
            join: getTextFromResource(getText, 'join'),
            earn: getTextFromResource(getText, 'earn'),
            ccRewards: getTextFromResource(getText, 'ccRewards'),
            signInForPrefix: getTextFromResource(getText, 'signInForPrefix'),
            fastFreeShipping: getTextFromResource(getText, 'fastFreeShipping'),
            allOrders: getTextFromResource(getText, 'allOrders'),
            noMinSpend: getTextFromResource(getText, 'noMinSpend'),
            newHere: getTextFromResource(getText, 'newHere'),
            joinNow: getTextFromResource(getText, 'joinNow')
        })
    }),
    {
        showSignInModal: actions.showSignInModal,
        showRegisterModal: actions.showRegisterModal,
        showBiRegisterModal: actions.showBiRegisterModal
    }
);
